<template>
  <div class="q-ma-sm q-gutter-y-sm">
    <div class="q-pa-md bg-white rounded-borders">
      <div class="row q-gutter-md items-start wrap">
        <q-input
          v-model="numeroListagem"
          label="Número Listagem"
          square
          class="col-3"
          @keyup="sanitizeInput('numeroListagem')"
          @keyup.enter="buscar"
        ></q-input>

        <q-btn
          color="primary"
          label="Buscar"
          @click="buscar"
          class="col-2"
        ></q-btn>

        <q-select
          v-model="modeloSelecionado"
          :options="modelosEtiquetas"
          option-value="value"
          option-label="label"
          label="Modelos de Etiqueta"
          class="col-4"
        ></q-select>

        <div class="q-mt-md">
          <q-btn 
            color="secondary" 
            label="Imprimir" 
            @click="imprimir" 
          />
        </div>
      </div>

      <q-table
        :rows="dados"
        :columns="colunas"
        row-key="codPro"
        class="q-mt-md custom-table"
        flat
        no-pagination
        :hide-pagination="true"
        :rows-per-page-options="[0]"
        :hide-header="!dados.length"
      >
        <template v-slot:header>
          <q-tr>
            <q-th>
              <q-checkbox
                v-model="selectAll"
                @update:model-value="toggleSelectAll"
              />
            </q-th>
            <q-th
              v-for="col in colunas"
              :key="col.name"
              class="custom-header"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td>
              <q-checkbox
                v-model="selectedRows"
                :val="props.row"
              />
            </q-td>
            <q-td>{{ props.row.codPro }}</q-td>
            <q-td>{{ props.row.desFam }}</q-td>
            <q-td>{{ props.row.desPro }}</q-td>
            <q-td>{{ props.row.desCor }}</q-td>
            <q-td>{{formatarPreco(props.row.preVen) }}</q-td>
            <q-td>{{ props.row.qtdPro }}</q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
  </div>
</template>

<script>
import { ref, watch, onMounted } from 'vue';
import { useQuasar } from 'quasar';
import EtiquetasServices from '@/services/etiquetas';
import ParametrosServices from '@/services/parametros';
import ImpressaoServices from '@/services/driver_impressao';

export default {
  name: "PesquisaLojaListagem",
  setup() {
    const $q = useQuasar();
    const numeroListagem = ref('');
    const dados = ref([]);
    const selectedRows = ref([]);
    const selectAll = ref(false);
    const modelosEtiquetas = ref([]);
    const modeloSelecionado = ref(null);
    const idModeloImpressora = ref(null);
    const nomeModeloImpressora = ref(null);
    const nomeComputadorImpressora = ref(null);

    const formatarPreco = (valor) => {
      const preco = parseFloat(valor.replace(',', '.')); 
      return !isNaN(preco) ? preco.toFixed(2).replace('.', ',') : '0,00'; 
    };

    const colunas = [
      { name: 'codPro', label: 'Código Produto', align: 'left', field: 'codPro', sortable: true },
      { name: 'desFam', label: 'Descrição Família', align: 'left', field: 'desFam', sortable: true },
      { name: 'desPro', label: 'Descrição Produto', align: 'left', field: 'desPro', sortable: true },
      { name: 'desCor', label: 'Cor', align: 'left', field: 'desCor', sortable: true },
      { name: 'preVen', label: 'Preço Venda', align: 'left', field: 'preVen', sortable: true },
      { name: 'qtdPro', label: 'Quantidade', align: 'left', field: 'qtdPro', sortable: true }
    ];

    const loadModelosEtiquetas = async () => {
      try {
        const modelos = await EtiquetasServices.listarModelosEtiquetas();
        modelosEtiquetas.value = modelos.map(modelo => ({
          label: modelo.modelo,
          value: modelo.id
        }));
      } catch (error) {
        exibirMensagem("Erro ao carregar modelos de etiquetas: " + error);
      }
    };

    const loadConfiguracaoLoja = async () => {
      try {
        let hostname = await ImpressaoServices.buscarHostname();
        const configuracao = await ParametrosServices.listarConfiguracaoLoja(hostname["nome_computador"]);
        if (configuracao == -1){
          console.log("loja n selecionada")
        }
        else {
          idModeloImpressora.value = configuracao[0].id_impressora;
          nomeModeloImpressora.value = configuracao[0].nome_impressora;
          nomeComputadorImpressora.value = configuracao[0].ip_server_impressao;
        }
      } catch (error) {
        exibirMensagem("Revise as configurações de impressão: " + error);
      }
    };
    
    onMounted(() => {
      loadModelosEtiquetas();
      loadConfiguracaoLoja();
    });

    const sanitizeInput = (field) => {
      if (field === 'numeroListagem') {
        numeroListagem.value = numeroListagem.value.replace(/[^0-9]+/g, '');
      }
    };

    const exibirMensagem = (mensagem, tipo = 'negative') => {
      $q.notify({
        message: mensagem,
        color: tipo,
        position: 'top',
        timeout: 3000
      });
    };

    const buscar = async () => {
      if (!numeroListagem.value) {
        exibirMensagem("Por favor, preencha o campo de busca.");
        return;
      }

      $q.loading.show();

      try {
        const params = {
          num_listagem: numeroListagem.value
        };

        const response = await EtiquetasServices.buscarListagemEtiqueta(params);
        if (response.produtos && response.produtos.length > 0) {
          dados.value = response.produtos.map(item => ({
            codPro: item.codPro,
            desFam: item.desFam,
            desPro: item.desPro,
            desCor: item.desCor,
            preVen: item.preVen,
            qtdPro: item.qtdPro,
            maiPvn: item.maiPvn,
            codBa2: item.codBa2,
            codPai: item.codPai,
            intDer: item.intDer,
            desCcp: item.desCcp,
            fxaPre: item.fxaPre,
            codDer: item.codDer,
            desExp: item.desExp,
            desNoo: item.desNoo,
            desTem: item.desTem,
            pirPro: item.pirPro,
            ultDat: item.ultDat,
            qrcode: item.qrcode
          }));
          exibirMensagem("Busca realizada com sucesso.", 'positive');
        } else {
          dados.value = [];
          exibirMensagem("Nenhuma listagem encontrada.");
        }

        // Limpar seleção
        selectedRows.value = [];
        selectAll.value = false;

      } catch (error) {
        exibirMensagem("A pesquisa informada não retornou dados.");
        console.log(error);
      } finally {
        $q.loading.hide();
      }
    };

    const imprimir = async () => {
      if (selectedRows.value.length === 0) {
        exibirMensagem("Por favor, selecione ao menos um produto para imprimir.");
        return;
      }

      if (!modeloSelecionado.value) {
        exibirMensagem("Por favor, selecione um modelo de etiqueta.");
        return;
      }

      if (!idModeloImpressora.value) {
        exibirMensagem("Modelo de impressora não configurado. Por favor, verifique as configurações da loja.");
        return;
      }

      $q.loading.show();

      try {

        const dadosParaImpressao = selectedRows.value.map(item => ({
          "preco_anterior": Number(item.maiPvn).toFixed(2).replace('.', ','),
          "novo_preco": Number(item.preVen).toFixed(2).replace('.', ','),
          "preco": Number(item.preVen).toFixed(2).replace('.', ','),
          "codigo_barras": item.codBa2,
          "codigo_pai_senior": item.codPai ? item.codPai: '',
          "cor": item.desCor ? item.desCor.substring(0, 15) : '',
          "derivacao": item.codDer ? item.codDer.substring(0, 6) : '',
          "codigo_produto": item.codPro,
          "marca": item.desCcp ? item.desCcp.substring(0, 15) : '',
          "familia": item.desFam ? item.desFam.substring(0, 18) : '',
          "descricao_produto": item.desPro ? item.desPro.substring(0, 20) : '',
          "intervalo_derivacao": item.intDer ? item.intDer.substring(0, 12) : '',
          "faixa_preco": item.fxaPre ? item.fxaPre.substring(0, 5) : '',
          "quantidade": item.qtdPro,
          "noos": item.noos ? item.noos: '',
          "piramide_produto": item.pirPro ? item.pirPro.substring(0, 10) : '',
          "ultima_data": item.ultDat,
          "tema": item.desTem ? item.desTem.substring(0, 10) : '',
          "exposicao": item.desExp ? item.desExp.substring(0, 10) : '',
          "qrcode": item.qrcode
        })); 

        const pesquisaPayload = {
          "dados": dadosParaImpressao,
          "id_modelo_etiqueta": modeloSelecionado.value.value,
          "id_modelo_impressora": idModeloImpressora.value
        };

        const { layout } = await EtiquetasServices.pesquisarEtiqueta(pesquisaPayload);
        await ImpressaoServices.imprimirEtiqueta(layout, nomeModeloImpressora.value, nomeComputadorImpressora.value);

        exibirMensagem("Etiqueta(s) enviada(s) para impressão com sucesso.", 'positive');
      } catch (error) {
        exibirMensagem("Erro ao enviar etiquetas para impressão: " + error);
      } finally {
        // Limpar seleção
        selectedRows.value = [];
        selectAll.value = false;

        $q.loading.hide();
      }
    };

    const toggleSelectAll = () => {
      if (selectAll.value) {
        selectedRows.value = dados.value.map(item => item);
      } else {
        selectedRows.value = [];
      }
    };

    watch(selectedRows, (newValue) => {
      if (newValue.length !== dados.value.length) {
        selectAll.value = false;
      } else {
        selectAll.value = true;
      }
    });

    return {
      numeroListagem,
      dados,
      colunas,
      selectedRows,
      selectAll,
      sanitizeInput,
      buscar,
      imprimir,
      exibirMensagem,
      toggleSelectAll,
      modelosEtiquetas,
      modeloSelecionado,
      idModeloImpressora,
      nomeModeloImpressora,
      nomeComputadorImpressora,
      formatarPreco
    };
  },
};
</script>

<style>
.bg-white {
  background-color: white;
}

.rounded-borders {
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.custom-table {
  color: var(--q-primary-text-color);
}

.q-table__bottom {
  display: none;
}

.custom-table .q-table__grid td {
  border-color: var(--q-input-border-color);
}

.custom-header {
  font-weight: bold;
  font-size: 2em;
}
</style>
